function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 24H2V12H11V24ZM11 6H0V10H11V6ZM13 24H22V12H13V24ZM13 6V10H24V6H13ZM17.369 0C14.422 0 12.698 3.477 12 5H17.345C20.838 5 20.875 0 17.369 0ZM16.573 3.621H14.53C15.269 2.5 15.969 1.655 16.872 1.655C18.044 1.655 18.1 3.621 16.573 3.621ZM6.655 5H12C11.302 3.477 9.578 0 6.631 0C3.125 0 3.162 5 6.655 5ZM7.128 1.655C8.031 1.655 8.731 2.5 9.47 3.621H7.427C5.9 3.621 5.956 1.655 7.128 1.655Z",
  fill: "url(#paint0_linear_20021958_75409)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.345 4.5H12.7932C13.1399 3.81022 13.6142 2.97921 14.2246 2.24974C15.0686 1.24102 16.1093 0.5 17.369 0.5C18.1184 0.5 18.6365 0.762998 18.969 1.12136C19.3085 1.48716 19.4848 1.98526 19.4816 2.49695C19.4785 3.00864 19.2961 3.50867 18.9508 3.8766C18.6123 4.23727 18.0906 4.5 17.345 4.5ZM9.77541 2.24974C10.3858 2.97921 10.8601 3.81022 11.2068 4.5H6.655C5.90943 4.5 5.38767 4.23727 5.04921 3.8766C4.70393 3.50867 4.52149 3.00864 4.51837 2.49695C4.51524 1.98526 4.69151 1.48716 5.03096 1.12136C5.3635 0.762998 5.88165 0.5 6.631 0.5C7.89066 0.5 8.93138 1.24102 9.77541 2.24974ZM14.1125 3.3458L13.6015 4.121H14.53H16.573C17.0676 4.121 17.4801 3.95879 17.7758 3.67376C18.0662 3.39378 18.2116 3.02612 18.2337 2.66884C18.2556 2.31459 18.1578 1.94343 17.9262 1.65146C17.686 1.3487 17.319 1.155 16.872 1.155C16.2494 1.155 15.733 1.45041 15.3002 1.8504C14.8724 2.24569 14.4849 2.78094 14.1125 3.3458ZM9.47 4.121H10.3985L9.88745 3.3458C9.51507 2.78094 9.12761 2.24569 8.69984 1.8504C8.26697 1.45041 7.75059 1.155 7.128 1.155C6.68095 1.155 6.31398 1.3487 6.07382 1.65146C5.84222 1.94343 5.74443 2.31459 5.76633 2.66884C5.78841 3.02612 5.93383 3.39378 6.22423 3.67376C6.51986 3.95879 6.93236 4.121 7.427 4.121H9.47ZM10.5 23.5H2.5V12.5H10.5V23.5ZM0.5 6.5H10.5V9.5H0.5V6.5ZM21.5 12.5V23.5H13.5V12.5H21.5ZM23.5 9.5H13.5V6.5H23.5V9.5Z",
  stroke: "white",
  strokeOpacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20021958_75409",
  x1: 0,
  y1: 0,
  x2: 24,
  y2: 23.025,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#755930"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.177083,
  stopColor: "#554328"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786458,
  stopColor: "#52422B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#775D37"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_20021958_75409",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(30.225 1.125) rotate(148.698) scale(23.9631 21.0132)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    d: "M11 24H2V12H11V24ZM11 6H0V10H11V6ZM13 24H22V12H13V24ZM13 6V10H24V6H13ZM17.369 0C14.422 0 12.698 3.477 12 5H17.345C20.838 5 20.875 0 17.369 0ZM16.573 3.621H14.53C15.269 2.5 15.969 1.655 16.872 1.655C18.044 1.655 18.1 3.621 16.573 3.621ZM6.655 5H12C11.302 3.477 9.578 0 6.631 0C3.125 0 3.162 5 6.655 5ZM7.128 1.655C8.031 1.655 8.731 2.5 9.47 3.621H7.427C5.9 3.621 5.956 1.655 7.128 1.655Z",
    fill: "url(#paint1_radial_20021958_75409)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 24H2V12H11V24ZM11 6H0V10H11V6ZM13 24H22V12H13V24ZM13 6V10H24V6H13ZM17.369 0C14.422 0 12.698 3.477 12 5H17.345C20.838 5 20.875 0 17.369 0ZM16.573 3.621H14.53C15.269 2.5 15.969 1.655 16.872 1.655C18.044 1.655 18.1 3.621 16.573 3.621ZM6.655 5H12C11.302 3.477 9.578 0 6.631 0C3.125 0 3.162 5 6.655 5ZM7.128 1.655C8.031 1.655 8.731 2.5 9.47 3.621H7.427C5.9 3.621 5.956 1.655 7.128 1.655Z",
    fill: "#DBC26A",
    style: {
      mixBlendMode: "overlay"
    }
  }), _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/giftIcon.eab00ce35c6b39b6075de7e9f43ac765.svg";
export { ForwardRef as ReactComponent };